import { t } from 'commons/libs/i18n'
import {
  dateAdd,
  dateSubtract,
  getEndOfDay,
  getToday,
  isDateBefore,
  isValidDate,
} from 'commons/utils/date'
import * as yup from 'yup'

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

const isValid = (value: string) => isValidDate(value, DATE_FORMAT)

export const notInFuture = (value: string) => {
  const endOfDayValue = getEndOfDay(value, DATE_FORMAT, DATE_FORMAT)
  const tomorrow = dateAdd(getToday(DATE_FORMAT), 1, 'day', DATE_FORMAT, DATE_FORMAT)
  return isDateBefore(endOfDayValue, tomorrow)
}

export const fairShareTrackingModalSchema = yup.object().shape({
  beginDate: yup
    .string()
    .required(() => t('common.validations.required'))
    .test(
      'is-valid-date',
      () => t('common.validations.invalidDate'),
      (value) => {
        if (!value) return false
        return isValid(value) && notInFuture(value)
      },
    )
    .test(
      'is-before-or-same-as-end',
      () => t('common.validations.invalidPeriod'),
      (value, context) => {
        if (!value) return false
        const endDate = context.parent.endDate
        if (!endDate) return false
        return isDateBefore(value, getEndOfDay(endDate, DATE_FORMAT, DATE_FORMAT))
      },
    )
    .test(
      'interval-greater-than-a-month',
      () => t('common.validations.intervalGreaterThanOneMonth'),
      (value, context) => {
        if (!value) return false
        const endDate = context.parent.endDate
        if (!endDate) return false
        return !isDateBefore(value, dateSubtract(endDate, 1, 'month', DATE_FORMAT, DATE_FORMAT))
      },
    ),
  endDate: yup
    .string()
    .required(() => t('common.validations.required'))
    .test(
      'is-valid-date',
      () => t('common.validations.invalidDate'),
      (value) => {
        if (!value) return false
        return isValid(value) && notInFuture(value)
      },
    )
    .test(
      'is-after-or-same-as-begin',
      () => t('common.validations.invalidPeriod'),
      (value, context) => {
        if (!value) return false
        const beginDate = context.parent.beginDate
        if (!beginDate) return false
        return isDateBefore(beginDate, getEndOfDay(value, DATE_FORMAT, DATE_FORMAT))
      },
    )
    .test(
      'interval-greater-than-a-month',
      () => t('common.validations.intervalGreaterThanOneMonth'),
      (value, context) => {
        if (!value) return false
        const beginDate = context.parent.beginDate
        if (!beginDate) return false
        return !isDateBefore(beginDate, dateSubtract(value, 1, 'month', DATE_FORMAT, DATE_FORMAT))
      },
    ),
})
